import './InformationOverlay.css';
export var InformationOverlayTriggerCSS = '_by0m3w0-3-5-0';
export var InformationOverlayTriggerIconCSS = '_by0m3w4-3-5-0';
export var InformationOverlayTriggerIconHoverCSS = '_by0m3w5-3-5-0';
export var InformationOverlayTriggerIconVariantsCSS = {primary:'_by0m3w6-3-5-0',success:'_by0m3w7-3-5-0',warning:'_by0m3w8-3-5-0',critical:'_by0m3w9-3-5-0',neutral:'_by0m3wa-3-5-0',onAccent:'_by0m3wb-3-5-0'};
export var InformationOverlayTriggerTextCSS = '_by0m3w1-3-5-0';